import React, { useEffect, useRef, useState } from 'react'
import { FormGroup, InputGroup, Label, Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Alert } from "reactstrap";
import { postPricesProviders, updatePricesProviders } from 'helpers/backend_helper';
import CreatableSelect from 'react-select/creatable';
import { useForm } from 'hooks/useForm';
import Flatpickr from 'react-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import * as moment from 'moment';

const ModalForm = ({ isOpenModal, setIsOpenModal, enterprise, getData, enterprises, products }) => {    

    const [isSubmit, setIsSubmit] = useState(false)
    const [error, setError] = useState (null)
    const [completed, setCompleted] = useState (null)
    const [btnSaveLoad, setBtnSaveLoad] = useState (false)
    const refForm = useRef('form-user-create');

    const { form, handleSpecificInput, resetForm} = useForm(enterprise);

    const handleSelect = (key, value) => {
        handleSpecificInput({
            key, 
            value
        });
    }

    const handleValidSubmit = async (event, values) => {
        setIsSubmit(true)
        if(!form.product?.value && !form.product?.value) return;

        const formData = {
            ...values,
            product: form.product.value,
            product_id: form.product.id,
            enterprise: form.enterprise.value,
            price_date: moment(form.price_date).format('YYYY-MM-DD'),
            id: form.id
        }

        setBtnSaveLoad(true)
        try {
          enterprise.id ? await updatePricesProviders(formData) : await postPricesProviders(formData);
          setError(null)
          setCompleted('Se completo la operación')
          if(!enterprise.id){
            handleSpecificInput({ key: 'product', value: '' })
            handleSpecificInput({ key: 'enterprise', value: '' })
            refForm && refForm.current.reset();
          }
          getData();
        } catch(error) {
          setError(error.toString())
          setCompleted(null)
        }
        setBtnSaveLoad(false)
    }

    useEffect(() => {
        setCompleted('')
        setIsSubmit(false)
        resetForm(enterprise)
    }, [isOpenModal, enterprise.id])
    

    return (
        <div>
            <Modal
                isOpen={isOpenModal}
                toggle={() => {
                  setIsOpenModal(false);
                }}
            >
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myModalLabel">
                      {enterprise.id ? 'Editar' : 'Crear'} proveedor
                    </h5>
                    <button
                      type="button"
                      onClick={() => {
                        setIsOpenModal(false);
                      }}
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                    <div className="modal-body">
                        <AvForm
                            ref={refForm}
                            className="form-horizontal"
                            onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                            }}
                        >
                            {error ? <Alert color="danger">{error}</Alert> : null}
                            {completed ? <Alert color="success">{completed}</Alert> : null}
                            <div className="mb-3">
                                <Label htmlFor="formrow-firstname-Input">Producto</Label>
                                <CreatableSelect
                                    isClearable
                                    options={products}
                                    onChange={(value) => handleSelect('product', value)}
                                    value={form.product}
                                    className={(isSubmit && !form.product) && `form-control is-invalid`}
                                    placeholder='Seleciona o coloca el producto'
                                />
                                { !form.product ? <div className="invalid-feedback">Campo requerido</div>:''}
                            </div>
                            <div className="mb-3">
                                <Label htmlFor="form row-firstname-Input">Empresa</Label>
                                <CreatableSelect
                                    isClearable
                                    options={enterprises}
                                    onChange={(value) => handleSelect('enterprise', value)}
                                    value={form.enterprise}
                                    className={(isSubmit && !form.enterprise) && `form-control is-invalid`}
                                    placeholder='Seleciona o coloca la empresa'
                                />
                                { !form.enterprise ? <div className="invalid-feedback">Campo requerido</div>:''}
                            </div>
                            <div className="mb-3">
                                <AvField
                                    name="weight"
                                    label="Peso Promedio"
                                    value={enterprise.weight}
                                    type="number"
                                    required
                                    errorMessage="Campo requerido"
                                    placeholder=""
                                />
                            </div>
                            <div className="mb-3">
                                <AvField
                                    name="price"
                                    label="Precio"
                                    value={enterprise.price}
                                    type="number"
                                    required
                                    errorMessage="Campo requerido"
                                    placeholder=""
                                />
                            </div>
                            <FormGroup className="mb-3">
                                <Label>Fecha</Label>
                                <InputGroup>
                                <Flatpickr
                                    className="form-control d-block"
                                    placeholder=""
                                    onChange={ (dates, parseDate) => {
                                        handleSpecificInput({
                                            key: 'price_date',
                                            value: dates[0]
                                        })
                                    }}
                                    value={form.price_date}
                                    options={{
                                        dateFormat: "Y-m-d",
                                        locale: Spanish,
                                        //defaultDate: new Date()
                                    }}
                                />
                                </InputGroup>
                            </FormGroup>
                            <input name="unit_id" type="hidden" /> 
                            <div className="text-center">
                                <button type="submit" className="btn btn-danger w-md" disabled={ btnSaveLoad }>
                                    <i className="fas fa-save"></i> Guardar
                                </button>
                                <button 
                                    onClick={() => {
                                        setIsOpenModal(false);
                                    }} 
                                    className="btn w-md btn-danger ms-2"
                                >
                                    <i className="fas fa-reply"></i> Atrás
                                </button>
                            </div>
                        </AvForm>
                    </div>
                    {/* <div className="modal-footer">
                        <button
                            type="button"
                            onClick={() => {
                            setIsOpenModal(false);
                            }}
                            className="btn btn-secondary "
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary "
                        >
                            Save changes
                        </button>
                    </div> */}
            </Modal>
        </div>
    )
}

ModalForm.propTypes = {
    isOpenModal: PropTypes.bool,
    setIsOpenModal: PropTypes.func,
    enterprise: PropTypes.object,
    getData: PropTypes.func,
    products: PropTypes.array,
    enterprises: PropTypes.array
};

export default ModalForm